export default function onUpdateQuestionCssClasses(survey, options) {
  var classes = options.cssClasses;
  if (
    options.question.getType() === "checkbox" &&
    options.question.choices.length > 12 &&
    options.question.choices.length !== 28
  ) {
    classes.root = "sv_q_checkbox-small";
  } else if (
    options.question.getType() === "checkbox" &&
    options.question.choices.length === 28
  ) {
    classes.root = "sv_q_checkbox-left";
  }

  if (options.question.customCssClass) {
    classes.root += ` ${options.question.customCssClass}`;
  }
}
